import { Card } from './card';
import { Files } from './files';
import { TGender } from './gender';
import { Role } from './role';

export type User = {
   _id: string;
   email: string;
   first_name: string;
   last_name: string;
   roles: Role[];
   verified: boolean;
   status: boolean;
   location?: Location;
   profile_photo?: Files;
   card?: Card;
   latest_cards?: Card;
   registration_step: TRegistrationStep;
   patient?: TPatient;
   phone: {
      country_number: string;
      phone_number: string;
   };
   package: TSubscription;
   clinic?: TClinic;
   partner?: TPartner;
   treatmentCondition?: PatientReferalConditionEnum;
};

export type Location = {
   address_1: string;
   address_2: string;
   post_code: string;
};

export const RegistrationStep = {
   PERSONAL_DETAILS: 'PERSONAL_DETAILS',
   PAYMENT: 'PAYMENT',
   KYC: 'KYC',
   APPLICATION_VERIFICATION: 'APPLICATION_VERIFICATION',
   COMPLETED: 'COMPLETED',
   CLINIC_DETAILS: 'CLINIC_DETAILS',
   CLINIC_PAYMENT: 'CLINIC_PAYMENT',
   PARTNER_DETAILS: 'PARTNER_DETAILS',
   PARTNER_PAYMENT: 'PARTNER_PAYMENT',
} as const;

export type TRegistrationStep = (typeof RegistrationStep)[keyof typeof RegistrationStep];

export type TPatient = {
   _id: string;
   deletedAt: string | null;
   date_of_birth: string;
   nationality: string;
   nhs_number: string;
   user_id: string;
   state: string;
   city: string;
   __v: number;
   qualifying_condition: string;
   specific_needs: string;
   medical_certificates?: Files[];
   gender: TGender;
   summery_care_certificates?: Files[];
   summary_cares: Files[];
   permissionOfDataSharing?: boolean;
   prescriptions: TPrescriptions[];
};

export type TSubscription = {
   _id: string;
   deletedAt: string | null;
   user_id: string;
   package_id: string;
   stripeSubscriptionId: string;
   price_id: string;
   start_date: string;
   due_date: string;
   expiry_date: string;
   amount: number;
   is_recurring: number;
   status: string;
   interval: number;
   createdAt: string;
   updatedAt: string;
   __v: number;
   package: TPackage;
};

export type TPackage = {
   _id: string;
   deletedAt: string | null;
   productId: string;
   productName: string;
   currency: string;
   amount: number;
   defaultPrice: string;
   patientsPerMonth: number;
   features: string[];
   minimum_signup_on: number;
   created_by: string;
   status: boolean;
   createdAt: string;
   updatedAt: string;
   __v: number;
};

export interface TClinic {
   _id: string;
   deletedAt: string | null;
   nationality: string;
   specialization: string[];
   min_appointment_fee: number;
   max_appointment_fee: number;
   availability: number;
   state: string;
   city: string;
   createdAt: string;
   updatedAt: string;
   __v: number;
   user_id: string;
   patient_referral_count?: number;
}

export interface TPartner {
   _id: string;
   deletedAt: string | null;
   websiteUrl: string;
   socialMedia: SocialMedum[];
   state: string;
   city: string;
   nationality: string;
   user_id: string;
   createdAt: string;
   updatedAt: string;
   __v: number;
}

export interface SocialMedum {
   platform: string;
   url: string;
   _id: string;
}

export enum PatientReferalConditionEnum {
   PATIENT_PROCEEDING_WITH_TREATMENT = 'PATIENT_PROCEEDING_WITH_TREATMENT',
   PATIENT_DECLINED_TREATMENT = 'PATIENT_DECLINED_TREATMENT',
   PATIENT_UNDECIDED = 'PATIENT_UNDECIDED',
}

export interface TPrescriptions {
   _id: string;
   patient_id: string;
   addBy: string;
   prescribeDate: Date;
   expiredAt: Date;
   medicineName: string;
   medicineAmount: number;
   prescriberName: string;
   clinicName: string;
   clinicContactNumber: string;
   clinicLogo: Files;
   clinicId: string;
   prescription: string;
   clinic: TClinic;
   patient: TPatient;
   clinicLogo_details: Files;
   clinic_details: TClinic;
   patient_details: TPatient;
   prescription_details: Files;
   medicationName: string;
   medicationVolume: number;
   medicationFrequency: string;
}
